import React from "react";
import { useQuery } from "../../../../../_utils/url_query_hook";
import TemplateTermInfo from "./template-term-info";
import { Nav } from "react-bootstrap";
import { useAcademicPartAllWithTemplateFormByIdAndTerm } from "../../../../../_hooks/academic_part/use-academic-part-all-with-template-form-by-id-and-term";

function ViewTemplateFormTabs() {
  const [key, setKey] = React.useState("1");
  const query = useQuery();
  const uuid = query.get("id");
  const templateName = query.get("template-name");
  const formHook = useAcademicPartAllWithTemplateFormByIdAndTerm(uuid, key);

  const changeTab = (k) => {
    setKey(k);
  };

  if (formHook.data)
    return (
      <div>
        <span style={{ fontWeight: "bold" }}>{templateName}</span>
        <hr />
        <div>
          <Nav variant="tabs" defaultActiveKey="1">
            <Nav.Item>
              <Nav.Link onClick={() => changeTab("1")} eventKey="1">
                Corte 1
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link onClick={() => changeTab("2")} eventKey="2">
                Corte 2
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link onClick={() => changeTab("3")} eventKey="3">
                Corte 3
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
        <div style={{ marginTop: "20px" }}>
          <TemplateTermInfo
            term={key}
            data={formHook.data ? formHook.data : []}
          />
        </div>
      </div>
    );
  else return <></>;
}

export default ViewTemplateFormTabs;
